import {
    cloudFunctionBaseUrl,
    getPricingApiUrl,
    vanarChainId,
    vanarChainName,
    vanarExplorerUrl,
    vanarRpcUrl,
} from "./constants";
// import { getToken } from "firebase/app-check";
// import { appCheck } from "../config/fireBaseConfig";
import Service from "./service";
import Web3 from "web3";
const web3 = new Web3(window?.ethereum);

export const getTruncatedAddress = (str) => {
    if (str && str !== "") {
        return str?.slice(0, 5) + str?.slice(-8).replace(/.(?=...)/g, "*");
    }
    return "";
};

export const getTruncatedTrx = (str, end) => {
    const endCharacterIndex = end ? end : 10;
    if (str && str !== "") {
        return (
            str?.slice(0, endCharacterIndex) +
            str?.slice(-7).replace(/.(?=...)/g, ".")
        );
    }
    return "";
};

export const handleDeepLink = () => {
    const a = document.createElement("a");
    a.href = process.env.REACT_APP_DEEP_LINK;
    a.click();
};

export const formatNumber = (number) => {
    if (typeof number === "string") {
        if (number.includes(".")) {
            const [integerPart, decimalPart] = number.split(".");
            const formattedDecimalPart = decimalPart.slice(0, 2); // Keep only 2 decimal digits
            return `${parseInt(integerPart, 10).toLocaleString(
                "en-US",
            )}.${formattedDecimalPart}`;
        }
        // If no decimal part, return integer with commas
        return `${Number(number).toLocaleString("en-US")}`;
    }

    if (!Number.isFinite(number)) {
        return "0";
    }

    const isNegative = number < 0;
    number = Math.abs(number);

    const suffixes = ["", "K", "M", "B", "T"];
    let suffixIndex = 0;

    // Reduce number with suffix logic
    while (number >= 1000 && suffixIndex < suffixes.length - 1) {
        number /= 1000;
        suffixIndex++;
    }

    // Truncate the number to 2 decimal places without rounding
    const truncateToDecimals = (num, decimals) => {
        const factor = Math.pow(10, decimals);
        return Math.floor(num * factor) / factor;
    };

    let formattedNumber;
    if (number % 1 !== 0) {
        formattedNumber = truncateToDecimals(number, 2).toString(); // Truncate decimals
    } else {
        formattedNumber = number.toString(); // Keep integers as they are
    }

    return (isNegative ? "-" : "") + formattedNumber + suffixes[suffixIndex];
};

export const fetchCoinData = async (coinGeckoId) => {
    try {
        const response = await Service.getCall(
            `https://api.coingecko.com/api/v3/simple/price?ids=${coinGeckoId}&vs_currencies=usd&include_market_cap=true`,
        );
        return response.data[coinGeckoId];
    } catch (error) {
        throw new Error(error);
    }
};

export const fetchBlockHeightFromRPC = async () => {
    try {
        const body = {
            jsonrpc: "2.0",
            method: "eth_blockNumber",
            params: [],
            id: 1,
        };
        const response = await Service.postCall(vanarRpcUrl, body);

        const data = response.data;
        const blockHeightHex = data.result;
        const blockHeight = parseInt(blockHeightHex, 16);
        return blockHeight;
    } catch (error) {
        console.error("Error fetching block number:", error);
    }
};

export const filterSearchAndSort = (data, options) => {
    const {
        statusKey,
        selectedStatus,
        searchKey,
        searchTerm,
        sortKey,
        sortOrder = "desc",
    } = options;

    return data
        ?.filter((item) => {
            const statusMatches = selectedStatus
                ? item[statusKey] === selectedStatus
                : true; // Skip filtering if selectedStatus doesn't exist

            const searchMatches =
                !searchTerm ||
                item[searchKey]
                    ?.toString()
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase());

            return statusMatches && searchMatches;
        })
        ?.sort((a, b) => {
            if (sortKey === "date") {
                return sortOrder === "desc"
                    ? b[sortKey].seconds - a[sortKey].seconds // Descending order
                    : a[sortKey].seconds - b[sortKey].seconds; // Ascending order
            }
            return sortOrder === "desc"
                ? b[sortKey] - a[sortKey] // Descending order
                : a[sortKey] - b[sortKey]; // Ascending order
        });
};

export const handleInputChange = (
    e,
    availableBalance,
    setInputValue,
    setIsConfirmDisabled,
    setIsMaxSelected,
    isTermsAgreed
) => {
    setIsMaxSelected(false);
    let input = e.target.value;
    // Remove non-numeric characters except for the first decimal point
    input = input.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");

    // Limit to two decimal places
    if (input.includes(".")) {
        input = input.split(".");
        input[1] = input[1].slice(0, 2);
        input = input.join(".");
    }

    // Ensure the number doesn't exceed the available token balance
    if (input === "" || parseFloat(input) <= availableBalance) {
        setInputValue(input);
        if (input !== "" && input > 0 && isTermsAgreed) {
            setIsConfirmDisabled(false);
        } else {
            setIsConfirmDisabled(true);
        }
    }
};

export const getGasTiers = async () => {
    try {
        const gasTierList = await Service.getCall(
            getPricingApiUrl[process.env.REACT_APP_ENV],
        );
        return gasTierList?.data;
    } catch (error) {
        console.log(error);
        throw new Error(error);
    }
};

export const fetchTransactionSignature = async (payload) => {
    try {
        // const appCheckTokenResponse = await getToken(appCheck, true);
        // const appCheckToken = appCheckTokenResponse.token;

        const res = await Service.postCall(
            cloudFunctionBaseUrl + "generateSignature",
            {
                payload: payload,
            },
            // {
            //     headers: {
            //         "X-Firebase-AppCheck": appCheckToken,
            //     },
            // }
        );

        return res.data;
    } catch (error) {
        throw new Error(error);
    }
};

export const copyToClipBoard = (data) => {
    navigator.clipboard.writeText(data);
};

export const handleDetailCardValues = (
    key,
    data,
    validatorData,
    isDelegator,
) => {
    const totalUnclaimedCommission =
        validatorData["rewards"]?.total_unclaimed_comission;
    const totalClaimedCommission =
        validatorData["rewards"]?.total_claimed_comission;
    const totalClaimedRewards = validatorData["rewards"]?.total_claimed_rewards;
    const totalUnclaimedRewards =
        validatorData["rewards"]?.totalRewards;
    const totalRewardsRecieved = validatorData["total_rewards_generated"];
    const commissionEarned = validatorData?.validator_commission_earned;

    if (key === "total_staked") {
        return formatNumber(data) + " $VANRY" ?? "N/A";
    } else if (key === "total_delegators" || key === "block_production") {
        return data;
    } else if (key === "total_rewards") {
        return formatNumber(totalRewardsRecieved) + " $VANRY";
    } else if (key === "rewards_earned") {
        return (
            formatNumber(totalUnclaimedRewards > 10 ? totalUnclaimedRewards : totalUnclaimedRewards?.toString()) +
            " $VANRY"
        );
    } else if (key === "commission_earned") {
        if (commissionEarned) {
            return formatNumber(commissionEarned) + " $VANRY";
        } else if (!isDelegator) {
            return formatNumber(totalClaimedCommission) + " $VANRY";
        }
        return (
            formatNumber(totalClaimedCommission + totalUnclaimedCommission) +
            " $VANRY"
        );
    } else if (key === "node_name") {
        return validatorData["name"];
    } else if (key === "amount") {
        return formatNumber(data) + "  $VANRY";
    } else {
        const percentage = data * 100;
        if (isNaN(percentage)) {
            return "N/A";
        }
        return data * 100 + "%";
    }
};

export const addSpace = (text) => {
    return text.replace(/([a-z])([A-Z])/g, "$1 $2");
};

export const filterData = (trxData, key, oprt, value, optionalValue) => {
    return trxData
        .filter((data) => {
            switch (oprt) {
                case "===":
                    return data[key] === value;
                case "!==":
                    return data[key] !== value;
                case ">":
                    return data[key] > value;
                case ">=":
                    return data[key] >= value;
                case "<":
                    return data[key] + optionalValue < value;
                case "<=":
                    return data[key] <= value;
                default:
                    throw new Error(`Unsupported operator: ${oprt}`);
            }
        })
        .map((data) => data); // This returns all the ids from the filtered data
};

export const formatPath = (pathname) => {
    return pathname
        .replace(/\//g, "") // Remove the '/'
        .split("-") // Split by '-'
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
        .join(" "); // Join the words with a space
};

export const checksum = (address) => {
    return web3?.utils?.toChecksumAddress(address);
};

export const formatScientificNumber = (num, decimalPlaces = 10) => {
    if (typeof num !== "number") {
        throw new Error("Input must be a number");
    }

    // Handle very small or very large numbers
    return num.toLocaleString("en-US", {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
        useGrouping: false,
    });
};

export const isScientificNotation = (num) => {
    if (typeof num !== "number") {
        throw new Error("Input must be a number");
    }

    // Convert the number to a string and check for scientific notation
    const numString = num.toString();
    return numString.includes("e") || numString.includes("E");
};

export const getValidatorImg = (name) => {
    return (
        process.env.REACT_APP_VALIDATOR_IMAGE_URL +
        name?.toLowerCase()?.split(" ")?.join("_") +
        ".png"
    );
};

export const addChain = async () => {
    try {
        const hexadecimalChainId = "0x" + Number(vanarChainId).toString(16);
        await window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
                {
                    chainId: hexadecimalChainId,
                    chainName: vanarChainName,
                    rpcUrls: [vanarRpcUrl],
                    nativeCurrency: {
                        name: "VANRY",
                        symbol: "VANRY",
                        decimals: 18,
                    },
                    blockExplorerUrls: [vanarExplorerUrl],
                },
            ],
        });
    } catch (error) {
        console.log({error});
    }
};
